import React from 'react';
import createReactClass from 'create-react-class';

import getNestedTopics from '../helpers/getNestedTopics';

import TopicTagMappingList from '../components/topicTagMappingList';

const TopicTagMappingListContainer = createReactClass({
  handleSectionToggle(isChecked, section) {
    const { allTopics, onTopicSelectionUpdate, topicSelection } = this.props;
    const nestedTopicIds = getNestedTopics(section, allTopics).map(({ id }) => id);

    const newSelection = topicSelection.filter(({ id }) => (
      id !== section.id && !nestedTopicIds.includes(id)
    ));

    if (isChecked) {
      newSelection.push(section);
    }

    onTopicSelectionUpdate(newSelection);
  },

  handleTopicToggle(isChecked, topic, section) {
    const { allTopics, onTopicSelectionUpdate, topicSelection } = this.props;

    if (isChecked) {
      return onTopicSelectionUpdate([...topicSelection, topic]);
    }

    const topicId = topic.id;
    const sectionId = section.id;
    const nestedTopics = getNestedTopics(section, allTopics);

    const newSelection = topicSelection.filter(({ id }) => (
      id !== topicId && id !== sectionId
    ));

    if (topicSelection.some((selected) => selected.id === sectionId)) {
      newSelection.push(...nestedTopics.filter(({ id }) => id !== topicId));
    }

    onTopicSelectionUpdate(newSelection);
  },

  render() {
    const {
      allTopics,
      hasSearch,
      topics,
      topicSelection,
    } = this.props;

    return (
      <TopicTagMappingList
        allTopics={allTopics}
        hasSearch={hasSearch}
        onSectionToggle={this.handleSectionToggle}
        onTopicToggle={this.handleTopicToggle}
        topics={topics}
        topicSelection={topicSelection}
      />
    );
  },
});

export default TopicTagMappingListContainer;
